/**
 * Start Slick op de productgalerij.
 *
 * Waarom dit bestand bestaat (16 aug 2026)
 * ----------------------------------------
 * Op de PDP werd Slick nooit geinitialiseerd. Het thema wacht met een
 * MutationObserver in theme.min.js tot de slider de class 'slick-initialized'
 * krijgt en haalt pas dan 'media-gallery--loading' en
 * 'media-gallery__slider--loading' weg. Omdat die init nooit kwam, bleef de
 * galerij permanent in laadstand staan en stonden alle slides gewoon als blokken
 * onder elkaar: 6252px aan inhoud in een venster van 447px. Op mobiel kon je
 * daar eindeloos doorheen scrollen, langs de lege slides van de kleuren die je
 * niet gekozen had.
 *
 * De rest van de keten is wel goed gebouwd en hangt hier alleen op:
 * assets/variant-image-automator.js polst 5 seconden lang of Slick klaar is
 * (waitForSlickAndFilter) en bindt dan bindSliderEvents, die het swipen
 * vastklemt binnen de slides van de gekozen kleur. Zonder init verliep die
 * polling en bleef die klem dus uit. Eén init repareert beide klachten.
 *
 * Daarom staat dit script in theme.liquid *voor* variant-image-automator.js:
 * beide zijn defer, dus ze draaien op volgorde en de automator treft Slick
 * meteen aan in plaats van erop te moeten wachten.
 */
(function () {
  'use strict';

  var SLIDER_SELECTOR = 'product-single .js-product-slider';
  var MAX_ATTEMPTS = 30; // 30 x 100ms = 3s na de wachttijd hieronder
  var attempts = 0;

  // Het thema initialiseert de galerij meestal zelf; het gaat alleen soms mis
  // (race bij het laden - dan blijft de galerij in laadstand staan en stapelen de
  // slides zich op tot een pagina die eindeloos doorscrollt). Dit script is dus
  // een vangnet, geen vervanging: we geven het thema eerst rustig de tijd en
  // springen pas in als het na deze wachttijd nog niet gelukt is. Zo blijft de
  // normale route intact, inclusief de MutationObserver in theme.min.js die de
  // thumbnailmaten zet.
  var WACHT_OP_THEMA_MS = 1500;

  function opties() {
    return {
      slidesToShow: 1,
      slidesToScroll: 1,
      // Niet oneindig: anders swipe je van de laatste foto van een kleur zo door
      // naar de eerste van een andere kleur, en dat is precies wat de klem in
      // variant-image-automator.js probeert te voorkomen.
      infinite: false,
      // De pijlen van dit thema zijn eigen elementen (.media-gallery__arrow) die
      // door de automator worden getoond en verborgen. Slick moet er geen eigen
      // set bovenop zetten.
      arrows: false,
      dots: true,
      adaptiveHeight: false,
      swipeToSlide: true,
      touchThreshold: 12,
      // De galerij bevat de foto's van alle kleuren. Lazy loading per slide zou
      // betekenen dat je bij een kleurwissel alsnog wacht; de automator regelt
      // het inladen zelf via hydrateGroup().
      lazyLoad: 'progressive'
    };
  }

  function init() {
    attempts++;

    var jq = window.jQuery;
    if (!jq || !jq.fn || typeof jq.fn.slick !== 'function') {
      if (attempts < MAX_ATTEMPTS) setTimeout(init, 100);
      return;
    }

    var sliders = document.querySelectorAll(SLIDER_SELECTOR);
    if (!sliders.length) {
      // Geen PDP, of de sectie is er nog niet. Even blijven kijken, daarna stoppen.
      if (attempts < MAX_ATTEMPTS) setTimeout(init, 100);
      return;
    }

    Array.prototype.forEach.call(sliders, function (slider) {
      var $slider = jq(slider);

      // Het thema was ons voor - prima, dat is de normale route. De stippen moeten
      // dan alsnog bijgewerkt worden, want die klopten ook op de gewone route niet:
      // Slick zet er één per foto van *alle* kleuren, terwijl je er maar een deel
      // van kunt bereiken.
      if ($slider.hasClass('slick-initialized')) {
        stemDotsAf($slider);
        bouwEigenStippen($slider);
        return;
      }
      // Een slider met één slide heeft Slick niet nodig, maar de --loading class
      // moet er dan wel af, anders blijft de galerij grijs staan.
      if (slider.children.length === 0) return;

      try {
        $slider.slick(opties());
      } catch (e) {
        if (window.console && console.warn) {
          console.warn('[beocca] Slick-init op de productgalerij mislukt:', e);
        }
        opruimen(slider);
        return;
      }

      // Zelf de laadstand opheffen. Normaal doet theme.min.js dat met een
      // MutationObserver die op 'slick-initialized' wacht, maar die observer begint
      // pas te kijken nadat hij is aangehangen - en wij zijn er eerder bij. Zonder
      // deze regel blijven de classes staan, en die zijn niet onschuldig:
      // de slider krijgt opacity 0 en de galerij visibility hidden. Dan is de hele
      // galerij dus onzichtbaar. Idempotent, dus als het thema het alsnog doet,
      // gebeurt er niets geks.
      opruimen(slider);

      stemDotsAf($slider);
      bouwEigenStippen($slider);
    });
  }

  /**
   * Eigen stippenbalk onder de galerij (17 aug 2026).
   *
   * Op mobiel is de thumbnailstrip verborgen (zie de B1-regels in
   * layout/theme.liquid) en initialiseert het thema Slick met `dots: false`.
   * Resultaat: geen enkele aanwijzing hoeveel foto's er zijn of waar je bent -
   * je swipet blind. Slick's eigen stippen alsnog aanzetten kan alleen met een
   * refresh, en die gooit de bindings van variant-image-automator.js eraf.
   * Vandaar een eigen, losstaand rijtje stippen.
   *
   * Het toont alleen de foto's van de gekozen kleur (currentPositions), net als
   * de klem op het swipen. Zijn die er niet, dan vallen we terug op alle slides.
   */
  function bouwEigenStippen($slider) {
    var slider = $slider[0];
    var gallery = slider.closest('.media-gallery');
    if (!gallery) return;

    // Slick's eigen stippen staan er al (bijv. via de fallback-init hierboven):
    // dan geen tweede rij eronder.
    if (slider.parentNode && slider.parentNode.querySelector('.slick-dots')) return;
    if (gallery.querySelector('.beocca-gallery-dots')) return;

    var lijst = document.createElement('ul');
    lijst.className = 'beocca-gallery-dots';
    lijst.setAttribute('aria-hidden', 'true');
    gallery.appendChild(lijst);

    var vorigeSleutel = '';

    function posities() {
      var filter = window.VariantImageFilter;
      if (filter && filter.currentPositions && filter.currentPositions.length) {
        return filter.currentPositions;
      }
      var alle = [];
      var slides = slider.querySelectorAll('.slick-slide');
      for (var i = 0; i < slides.length; i++) alle.push(i);
      return alle;
    }

    function huidigeSlide() {
      try {
        return $slider.slick('slickCurrentSlide');
      } catch (e) {
        return 0;
      }
    }

    function teken() {
      var pos = posities();
      var sleutel = pos.join(',');

      if (sleutel !== vorigeSleutel) {
        vorigeSleutel = sleutel;
        lijst.innerHTML = '';

        // Eén foto betekent niets om tussen te wisselen; dan geen stippen.
        if (pos.length < 2) return;

        pos.forEach(function (index) {
          var li = document.createElement('li');
          var knop = document.createElement('button');
          knop.type = 'button';
          knop.className = 'beocca-gallery-dots__dot';
          knop.setAttribute('data-slide', index);
          var labelTemplate = (window.theme && window.theme.t && window.theme.t.gallery_position) || '';
          knop.setAttribute(
            'aria-label',
            labelTemplate
              .replace('[current]', pos.indexOf(index) + 1)
              .replace('[total]', pos.length)
          );
          knop.addEventListener('click', function () {
            try { $slider.slick('slickGoTo', index); } catch (e) {}
          });
          li.appendChild(knop);
          lijst.appendChild(li);
        });
      }

      var actief = huidigeSlide();
      Array.prototype.forEach.call(lijst.querySelectorAll('.beocca-gallery-dots__dot'), function (knop) {
        var mijn = Number(knop.getAttribute('data-slide'));
        knop.setAttribute('aria-current', mijn === actief ? 'true' : 'false');
      });
    }

    teken();
    $slider.on('afterChange', teken);

    // currentPositions verandert bij een kleurwissel zonder eigen event; zelfde
    // pollingaanpak als de rest van dit bestand.
    setInterval(teken, 300);
  }

  /**
   * De galerij bevat de foto's van alle kleuren, dus Slick zet net zoveel stippen
   * neer. variant-image-automator.js klemt het swipen binnen de slides van de
   * gekozen kleur (currentPositions), maar de stippen daarbuiten bleven staan:
   * 24 stippen terwijl er 8 bereikbaar zijn. Die verbergen we hier.
   */
  function stemDotsAf($slider) {
    var slider = $slider[0];

    function sync() {
      var filter = window.VariantImageFilter;
      var posities = filter && filter.currentPositions;
      var dots = slider.parentNode
        ? slider.parentNode.querySelectorAll('.slick-dots > li')
        : [];
      if (!dots.length) return;

      Array.prototype.forEach.call(dots, function (dot, index) {
        var binnenBereik = !posities || posities.indexOf(index) !== -1;
        dot.style.display = binnenBereik ? '' : 'none';
      });
    }

    sync();
    $slider.on('afterChange', sync);

    // currentPositions verandert bij een kleurwissel zonder dat daar een event
    // voor is dat wij kunnen afvangen; vandaar dezelfde pollingaanpak als de
    // automator zelf gebruikt. Alleen werk doen als er echt iets wijzigde.
    var vorige = '';
    setInterval(function () {
      var filter = window.VariantImageFilter;
      var sleutel = filter && filter.currentPositions
        ? filter.currentPositions.join(',')
        : '';
      if (sleutel === vorige) return;
      vorige = sleutel;
      sync();
    }, 300);
  }

  /**
   * Het thema haalt de --loading classes normaal zelf weg zodra het
   * 'slick-initialized' ziet. Dit is puur voor het geval Slick alsnog omvalt:
   * dan liever een zichtbare stapel dan een pagina die grijs blijft.
   */
  function opruimen(slider) {
    slider.classList.remove('media-gallery__slider--loading');
    var gallery = slider.closest('.media-gallery');
    if (gallery) gallery.classList.remove('media-gallery--loading');
  }

  /**
   * Wanneer begint de wachttijd? (20 sep 2026)
   *
   * Het thema start Slick niet bij het laden maar via een IntersectionObserver
   * (generateFireOnViewObserver in theme.min.js), en die vuurt pas als de pagina
   * echt getekend wordt. In een achtergrondtab, een prerender of een in-app browser
   * die nog niet vooraan staat gebeurt dat dus nog niet - terwijl een gewone
   * setTimeout daar wel afloopt. Dan won dit vangnet de race, en gooide het thema
   * zodra de tab zichtbaar werd alsnog zijn eigen init over een al geinitialiseerde
   * slider heen:
   *   TypeError: Cannot read properties of null (reading 'add')   (Chrome)
   *   null is not an object (evaluating 'i.$slides.add')          (Safari)
   * Clarity telde dat in 25 sessies per maand. Daarom hangt de wachttijd nu aan een
   * eigen observer op dezelfde slider: die meldt zich in hetzelfde frame als die van
   * het thema (het thema staat eerder in de rij), dus de klok loopt pas vanaf het
   * moment dat het thema zijn kans heeft gehad.
   */
  function start() {
    var sliders = document.querySelectorAll(SLIDER_SELECTOR);
    if (!sliders.length || !('IntersectionObserver' in window)) {
      setTimeout(init, WACHT_OP_THEMA_MS);
      return;
    }

    var gestart = false;
    var observer = new IntersectionObserver(function (entries) {
      if (gestart) return;
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          gestart = true;
          observer.disconnect();
          setTimeout(init, WACHT_OP_THEMA_MS);
          return;
        }
      }
    });
    Array.prototype.forEach.call(sliders, function (slider) {
      observer.observe(slider);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
